/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { Expression, List, SiteSpace, SiteSpaceMovePosition, SiteSpacePath } from "./data-contracts";

/**
 * No description
 * @tags site-spaces
 * @name AddSpaceToSite
 * @summary Add a space to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces
 * @secure
 */

// @ts-ignore
export const addSpaceToSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** ID of the space */
    spaceId: string;
    /** ID of the section to add the space to. If not provided, the space will be added to the default section or at the root level if the site has no sections. */
    sectionId?: string;
  };
  RequestHeaders: {};
  ResponseBody: SiteSpace;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
  method: "post",
  streaming: false,
  tags: ["site-spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces, critical
 * @name ListSiteSpaces
 * @summary List all the site spaces
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces
 * @secure
 */

// @ts-ignore
export const listSiteSpaces: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If true, only the default site space will be returned. If false, only the non-default site spaces are returned. If undefined, all site spaces are returned. */
    default?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSpace[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces",
  method: "get",
  streaming: false,
  tags: ["site-spaces", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces
 * @name UpdateSiteSpaceById
 * @summary Update a site space
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
 * @secure
 */

// @ts-ignore
export const updateSiteSpaceById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Path to the space on the site */
    path?: SiteSpacePath;
    /** Conditional expression used to evaluate whether the site space should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
    /** The content that this site space points to. If not set, the space will remain unchanged. */
    spaceId?: string;
    /** Whether the site space is hidden. If true, the site space will not be shown in the site's navigation. If not set, the hidden state will remain unchanged. If set to false, the site space will be shown in site navigation. */
    hidden?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: SiteSpace;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
  method: "patch",
  streaming: false,
  tags: ["site-spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces
 * @name DeleteSiteSpaceById
 * @summary Delete a site space
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSpaceById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}",
  method: "delete",
  streaming: false,
  tags: ["site-spaces"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-spaces
 * @name MoveSiteSpace
 * @summary Move a site space to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The position where to move the site space. When not provided the site space is moved at the end of the site. */
    position?: SiteSpaceMovePosition;
  };
  RequestHeaders: {};
  ResponseBody: SiteSpace;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/move",
  method: "post",
  streaming: false,
  tags: ["site-spaces"],
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
